module.exports = __webpack_public_path__ + "img/tower-control.cc8edfcd.svg";